import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import {
  HTTP_INTERCEPTORS,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { HeaderComponent } from './components/header/header.component';
import { SignupComponent } from './components/signup/signup.component';
import { SideNavComponent } from './components/side-nav/side-nav.component';
import { LoginComponent } from './components/login/login.component';
import { CommonModule, TitleCasePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { QuotationModule } from './quotation/quotation.module';
import { ImgSliderComponent } from './components/img-slider/img-slider.component';
import { OtpVerificationComponent } from './components/otp-verification/otp-verification.component';
import { MobileInputComponent } from './components/mobile-input/mobile-input.component';
import { CountryPickerComponent } from './components/country-picker/country-picker.component';
import { GlobalErrorHandler } from './service/GlobalErrorHandler';
import { AuthInterceptor } from './interceptors/auth.interceptor';
import { ToastrModule } from 'ngx-toastr';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { ErrorInterceptor } from './interceptors/error.interceptor';
import { provideTranslateCompiler, TranslateModule,  } from '@ngx-translate/core';
import {provideTranslateHttpLoader} from '@ngx-translate/http-loader';

@NgModule({
  declarations: [
    AppComponent,
    HeaderComponent,
    SignupComponent,
    SideNavComponent,
    LoginComponent,
    ImgSliderComponent,
    OtpVerificationComponent,
    MobileInputComponent,
  ],
  bootstrap: [AppComponent],
  exports: [],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    TitleCasePipe,
    TranslateModule.forRoot({
      loader: provideTranslateHttpLoader({
          prefix: '/assets/i18n/',
          suffix: '.json'
      }),
      lang: 'en',
      fallbackLang: 'en',
    }),
    ToastrModule.forRoot(),
    AppRoutingModule,
    QuotationModule,
    CountryPickerComponent,
  ],
  providers: [
    {
      provide: ErrorHandler,
      useClass: GlobalErrorHandler,
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: AuthInterceptor,
      multi: true,
    },
    { provide: HTTP_INTERCEPTORS, useClass: ErrorInterceptor, multi: true },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
